import classNames from 'classnames'
import React from 'react'

interface Props {
  value: string
}

export const Percentage: React.FC<Props> = ({ value }) => {
  const parsedValue = parseFloat(value)
  return (
    <span
      className={classNames({
        'stk-text-danger': parsedValue < 0,
        'stk-text-success': parsedValue > 0,
      })}
    >
      {value}
    </span>
  )
}
